import type { ReactNode } from 'react';
import React from 'react';

import type { ReactChildrenProps } from '@/types/react';
import styles from './index.module.scss';

export function TopBackground({ children }: ReactChildrenProps): ReactNode {
  return <div className={styles.topBackground}>{children}</div>;
}
